import {createContext} from "react";

export interface DialogDataContainer {
    show: boolean,
    element: JSX.Element,
    key: string,
    onClose?: (result?: any) => void
}

export interface DialogContextType {
    dialogs: DialogDataContainer[],
    openDialog: (element: JSX.Element, onClose?: (result?: any) => void) => void,
    closeDialog: (result?: any) => void
}

const initialValue: DialogContextType = {
    dialogs: [],
    openDialog: (element: JSX.Element, onClose?: (result?: any) => void) => {
    },
    closeDialog: (result?: any) => {
    }
}

export const DialogContext = createContext(initialValue);

